import moment from "moment/moment";
import { DomainReport, IPReport, UrlReport } from "./@types";

// URL Report Issues
export const urlReportClassificationIssue = (urlReport: UrlReport) =>
  Number(
    urlReport?.classification === "malicious" ||
      urlReport?.classification === "suspicious"
  );

export const urlReportCategoriesIssue = (urlReport: UrlReport) =>
  urlReport?.third_party_reputations.sources.filter(
    src => src.detection === "malicious"
  ).length;

export const urlReportThirdPartyRepIssue = (urlReport: UrlReport) =>
  Number(urlReport?.third_party_reputations?.statistics?.malicious > 0);

export const urlReportTopThreatIssue = (urlReport: UrlReport) =>
  Number((urlReport?.analysis?.top_threats?.length ?? 0) > 0);

export const urlReportLastAnalysisIssue = (urlReport: UrlReport) => {
  if (!urlReport?.analysis?.last_analysis?.analysis_time) return 0;
  const lastAnalyzed = moment(
    urlReport?.analysis?.last_analysis?.analysis_time
  );
  const sixMontshAgo = moment().subtract(6, "months");
  return Number(lastAnalyzed.isBefore(sixMontshAgo));
};

// Domain Report Issues
export const domainReportThirdPartyRepIssue = (domainReport: DomainReport) =>
  Number(domainReport?.third_party_reputations?.statistics?.malicious > 0);

export const domainReportDownloadedFilesIssue = (domainReport: DomainReport) =>
  Number(domainReport?.downloaded_files_statistics.malicious > 0);

export const domainReportCategoriesIssue = (domainReport: DomainReport) =>
  domainReport?.third_party_reputations.sources.filter(
    src => src.detection === "malicious"
  ).length;

export const domainReportTopThreatIssue = (domainReport: DomainReport) =>
  Number(domainReport?.top_threats.length > 0);

export const domainReportLastSeenIssue = (domainReport: DomainReport) => {
  if (!domainReport?.last_seen) return 0;
  const lastSeen = moment(domainReport?.last_seen);
  const threeMonths = moment().subtract(3, "months");
  return Number(lastSeen.isBefore(threeMonths));
};

// IP Report Issues
export const ipReportThirdPartyRepIssue = (ipReport: IPReport) =>
  Number(ipReport?.third_party_reputations?.statistics?.malicious > 0);

export const ipReportDownloadedFilesIssue = (ipReport: IPReport) =>
  Number(ipReport?.downloaded_files_statistics.malicious > 0);

export const ipReportCategoriesIssue = (ipReport: IPReport) =>
  ipReport?.third_party_reputations.sources.filter(
    src => src.detection === "malicious"
  ).length;

export const ipReportTopThreatIssue = (ipReport: IPReport) =>
  Number(ipReport?.top_threats.length > 0);
